import { useState } from 'react';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { publicSurveyService } from '../services/publicSurvey.service';

interface UsePublicSurveyListsOptions {
  enabled?: boolean;
}

export function usePublicSurveyLists(options: UsePublicSurveyListsOptions = {}) {
  const { enabled = true } = options;
  const [activePage, setActivePage] = useState(1);
  const [completedPage, setCompletedPage] = useState(1);

  const activeQuery = useQuery({
    queryKey: ['public-surveys', 'ACTIVE', activePage],
    queryFn: () => publicSurveyService.list('ACTIVE', activePage),
    enabled,
    placeholderData: keepPreviousData,
  });

  const completedQuery = useQuery({
    queryKey: ['public-surveys', 'COMPLETED', completedPage],
    queryFn: () => publicSurveyService.list('COMPLETED', completedPage),
    enabled,
    placeholderData: keepPreviousData,
  });

  return {
    activePage,
    setActivePage,
    completedPage,
    setCompletedPage,
    activeQuery,
    completedQuery,
  };
}
